import { Routes } from '@angular/router';
import { AuthenticationGuard } from './core/authentication/authentication.guard';
import { BrowsercheckGuard } from './core/browsercheck.guard';


export const routes: Routes = [
  {
    path: '',
    // canActivate: [BrowsercheckGuard],
    children: [
      {
        path: '',
        loadComponent: () => {
          return import('./home/home.component').then((m) => m.HomeComponent);
        },
        canActivate: [AuthenticationGuard],
        data: { title: 'SMXstudio Home', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'home',
        loadComponent: () => {
          return import('./home/home.component').then((m) => m.HomeComponent);
        },
        canActivate: [AuthenticationGuard],
        data: { title: 'SMXstudio Home', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'login/:redirect',
        loadComponent: () => {
          return import('./login/login.component').then(
            (m) => m.LoginComponent
          );
        },
        data: { title: 'SMXstudio Login', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'finish-sign-up/:email/:demo/:finishupcode',
        loadComponent: () => {
          return import('./login/finish-sign-up/finish-sign-up.component').then(
            (m) => m.FinishSignUpComponent
          );
        },
        data: { title: 'SMXstudio Accedi', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'new-user-profile/:email',
        loadComponent: () => {
          return import(
            './login-form/new-user-profile/new-user-profile.component'
          ).then((m) => m.NewUserProfileComponent);
        },
        data: { title: 'SMXstudio Profilo', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'invalid-credentials',
        loadComponent: () => {
          return import(
            './logged-user/invalid-credentials/invalid-credentials.component'
          ).then((m) => m.InvalidCredentialsComponent);
        },
      },
      {
        path: 'loggedin',
        loadComponent: () => {
          return import('./logged-in/logged-in.component').then(
            (m) => m.LoggedInComponent
          );
        },
        data: { title: 'SMXstudio Accedi', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'loggeduser',
        loadComponent: () => {
          return import('./logged-user/logged-user.component').then(
            (m) => m.LoggedUserComponent
          );
        },
        data: { title: 'SMXstudio Accedi', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'user-profile/:email',
        loadComponent: () => {
          return import('./user-profile/user-profile.component').then(
            (m) => m.UserProfileComponent
          );
        },
        data: { title: 'SMXstudio Profilo', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'signin-link-sent',
        loadComponent: () => {
          return import(
            './login-form/signin-link-sent/signin-link-sent.component'
          ).then((m) => m.SigninLinkSentComponent);
        },
      },
      {
        path: 'forgot-password-sent',
        loadComponent: () => {
          return import(
            './login/forgot-password-sent/forgot-password-sent.component'
          ).then((m) => m.ForgotPasswordSentComponent);
        },
      },
      {
        path: 'new-password/:redirect',
        loadComponent: () => {
          return import(
            './force-change-password/force-change-password.component'
          ).then((m) => m.ForceChangePasswordComponent);

        }
      },
      {
        path: 'workspace',
        loadComponent: () => {
          return import('./workspace/workspace.component').then(
            (m) => m.WorkspaceComponent
          );
        },
        canActivate: [AuthenticationGuard],
        data: { title: 'SMXstudio Workspace', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'admin-page',
        loadComponent: () => {
          return import(
            './admin-page-container/admin-page-container.component'
          ).then((m) => m.AdminPageContainerComponent);
        },
        data: { title: 'SMXstudio Amministrazione', favicon: 'assets/favicon.ico' }
      },
      {
        path: 'doc-shared/:docId',
        loadComponent: () => {
          return import(
            './doc-shared/doc-shared.component'
          ).then((m) => m.DocSharedComponent);
        }
      },
      {
        path: 'share-classroom/:docId/:docType',
        loadComponent: () => {
          return import('./share-classroom/share-classroom.component').then(
            (m) => m.ShareClassroomComponent
          );
        },
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'share-classroom/:docId/:docType/:googleId',
        loadComponent: () => {
          return import('./share-classroom/share-classroom.component').then(
            (m) => m.ShareClassroomComponent
          );
        },
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'map-show/:docId',
        loadComponent: () => {
          return import(
            './map-show-container/map-show-container.component'
          ).then((m) => m.MapShowContainerComponent);
        }
      },
      {
        path: 'guestspace',
        loadComponent: () => {
          return import('./guestspace/guestspace.component').then(
            (m) => m.GuestSpaceComponent
          );
        }
      },
      {
        path: 'demo',
        loadComponent: () => {
          return import('./demo/demo.component').then(
            (m) => m.DemoComponent
          );
        }
      },
      {
        path: 'help-center',
        loadComponent: () => {
          return import('./help-center/help-center.component').then(
            (m) => m.HelpCenterComponent
          );
        }
      },
      {
        path: 'download-personal-data',
        loadComponent: () => {
          return import('./download-personal-data/download-personal-data.component').then(
            (m) => m.DownloadPersonalDataComponent
          );
        },
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'importFromDrive',
        loadComponent: () => {
          return import('./import-from-drive/import-from-drive.component').then(
            (m) => m.ImportFromDriveComponent
          );
        },
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'user-stats/:email/:username',
        loadComponent: () => {
          return import('./user-stats/user-stats.component').then(
            (m) => m.UserStatsComponent
          );
        },
        data: { title: 'SMX studio Statistiche utente', favicon: 'assets/favicon.ico' },
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'multi-stats/:subscriptionId',
        loadComponent: () => {
          return import('./multi-stats/multi-stats.component').then(
            (m) => m.MultiStatsComponent
          );
        },
        data: { title: 'SMX studio Statistiche admin', favicon: 'assets/favicon.ico' },
        canActivate: [AuthenticationGuard],
      }
    ]
  },
  // { path: '**', component: NotFoundComponent },
];
